// extracted by mini-css-extract-plugin
module.exports = {"choice_not_found_wrapper":"ChoiceNotFound_choice_not_found_wrapper__8CWzt","text":"ChoiceNotFound_text__HWZEL"};